import React, { useState, useEffect } from 'react';
import { useAuth } from './context/AuthContext';
import { SHOW_DEBUG_WINDOW } from './config';
import './DebugWindow.css';

const DebugWindow = () => {
    const {
        sessionStartTime,
        lastActivity,
        lastRefreshTime,
        INACTIVITY_TIMEOUT,
        TOKEN_REFRESH_INTERVAL
    } = useAuth();

    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        if (!SHOW_DEBUG_WINDOW) return;

        const interval = setInterval(() => {
            setNow(Date.now());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    if (!SHOW_DEBUG_WINDOW) return null;

    const formatTime = (timestamp) => {
        if (!timestamp) return 'N/A';
        return new Date(timestamp).toLocaleTimeString();
    };

    const formatDuration = (ms) => {
        if (ms < 0) return '00:00:00';
        const seconds = Math.floor((ms / 1000) % 60);
        const minutes = Math.floor((ms / (1000 * 60)) % 60);
        const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const timeUntilExpiration = lastActivity.current ? (lastActivity.current + INACTIVITY_TIMEOUT) - now : 0;
    const timeUntilRefresh = lastRefreshTime.current ? (lastRefreshTime.current + TOKEN_REFRESH_INTERVAL) - now : 0;

    return (
        <div className="debug-window">
            <div>Start Time: {formatTime(sessionStartTime)}</div>
            <div>Session Expires In: {formatDuration(timeUntilExpiration)}</div>
            <div>Token Refresh In: {formatDuration(timeUntilRefresh)}</div>
            <div>Last Activity: {formatTime(lastActivity.current)}</div>
        </div>
    );
};

export default DebugWindow;
